import { Link } from 'react-router-dom';
import { animeList, categories } from '@/mocks/anime';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-8 py-10">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">热门分类</h2>
          <p className="text-sm text-foreground-500 mt-1">按类型快速进入，找到属于你的那部动漫</p>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
        {categories.map((category) => {
          const count = animeList.filter((anime) => anime.type === category.name).length;
          return (
            <Link
              key={category.slug}
              to={`/category/${encodeURIComponent(category.slug)}`}
              className="group flex flex-col items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${category.icon} text-xl`}></i>
              </span>
              <span className="text-center">
                <span className="block font-heading font-semibold text-sm text-foreground-950">
                  {category.name}
                </span>
                <span className="block text-xs text-foreground-500 mt-0.5">{count} 部作品</span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}